import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { DEVICE_SIZE } from '../../../../../core/models/others.model';
import { ScreenViewModule } from '../../../../../core/directives/screen-view/_screen-view.module';

@Component({
  selector: 'demo-screen-view',
  standalone: true,
  imports: [CommonModule, ScreenViewModule],
  templateUrl: './demo-screen-view.component.html',
  styleUrl: './demo-screen-view.component.scss',
})
export class DemoScreenViewComponent {
  DEVICE_SIZE = DEVICE_SIZE;
}
